function About() {
  return (
    <>
      {" "}
      <h1 style={{ fontSize: "100px" }}> Do you want to see mee.</h1>
      <div style={{ backgroundColor: "red", height: "100vh", width: "100%" }}>
        {" "}
        <h1>lets make a cart</h1>{" "}
      </div>
    </>
  );
}
export default About;
